/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

import * as types from '../types'

const app = (
  state = {
    initialized: false,
  },
  action
) => {
  switch (action.type) {
    case types.app.INITIALIZED_SUCCESS:
      return {
        initialized: true,
      }
    case types.app.INITIALIZED_ERROR:
      return {
        initialized: false,
      }
    default:
      return state
  }
}

export default app
